import React from 'react';
import { T } from '../components/Translations';

/**
 * the template to show on not found
 * @exports NotFound
 */
export default function NotFound() {
    return (<div><T>text.not_found</T></div>);
}